import React from "react";

export function PageHeader({ eyebrow, title, subtitle, actions }) {
  return (
    <div className="border-b border-[#E5E7EB] bg-white px-4 sm:px-6 lg:px-8 py-5 sm:py-6 lg:py-8 flex flex-col sm:flex-row sm:items-start sm:justify-between gap-4">
      <div className="min-w-0">
        {eyebrow && <div className="label-caps mb-2 sm:mb-3" data-testid="page-eyebrow">{eyebrow}</div>}
        <h1 className="font-display font-black text-2xl sm:text-3xl lg:text-4xl tracking-tight leading-none text-[#111827]" data-testid="page-title">
          {title}
        </h1>
        {subtitle && <p className="mt-2 sm:mt-3 text-sm text-[#6B7280] max-w-2xl">{subtitle}</p>}
      </div>
      {actions && <div className="flex items-center gap-3 shrink-0 flex-wrap">{actions}</div>}
    </div>
  );
}

export function StatCard({ label, value, hint, testId }) {
  return (
    <div className="bg-white border border-[#E5E7EB] p-4 sm:p-6" data-testid={testId}>
      <div className="label-caps">{label}</div>
      <div className="mt-2 sm:mt-3 font-display font-black text-2xl sm:text-3xl tracking-tight text-[#111827] break-words">
        {value}
      </div>
      {hint && <div className="mt-2 text-xs text-[#6B7280]">{hint}</div>}
    </div>
  );
}
